<div class="tabs-container">
  <ul class="c-popover-black-container">
    <li
      *ngFor="let tab of tabItem; let i = index"
      (click)="selectTab(tab)"
      [class.active]="tab.active"
    >
      <ng-container *ngIf="i == 0">
        <img
          class="img-icon"
          [src]="'icons/' + tab.tabIcon"
          alt=""
          (mouseenter)="p1.open()"
          [ngbPopover]=""
          #p1="ngbPopover"
          placement="top"
          (mouseleave)="p1.close()"
        />
      </ng-container>

      <ng-container *ngIf="i == 1">
        <img
          class="img-icon"
          [src]="'icons/' + tab.tabIcon"
          alt=""
          (mouseenter)="p2.open()"
          [ngbPopover]=""
          #p2="ngbPopover"
          placement="top"
          (mouseleave)="p2.close()"
        />
      </ng-container>

      <ng-container *ngIf="i == 2">
        <img
          class="img-icon"
          [src]="'icons/' + tab.tabIcon"
          alt=""
          (mouseenter)="p3.open()"
          [ngbPopover]=""
          #p3="ngbPopover"
          placement="top"
          (mouseleave)="p3.close()"
        />
      </ng-container>

      <a href="javascript: void(0);">{{ tab.tabTitle }}</a>
    </li>
    <ng-template #popOverBatch>
      <div class="c-popover-black">
        <p>{{ "plp.popOverBatch" | cxTranslate }}</p>
      </div>
    </ng-template>
    <ng-template #popOverDetails>
      <div class="c-popover-black">
        <p>{{ "plp.popOverDetails" | cxTranslate }}</p>
      </div>
    </ng-template>
  </ul>
  <ng-content></ng-content>
</div>
